// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("jquery-ui/ui/widgets/sortable")
require("bootstrap.bundle")
require("sb-admin-2.min")
require("jquery.easing.min")
require("Chart.min")
require("select2")

import * as ActiveStorage from '@rails/activestorage';

import $ from 'jquery'
import select2 from 'select2'
import slider from 'ion-rangeslider';

// Import TinyMCE
import tinymce from 'tinymce/tinymce';
//
// Default icons are required for TinyMCE 5.3 or above
import 'tinymce/icons/default';

// A theme is also required
import 'tinymce/themes/silver';

// Any plugins you want to use has to be imported
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';

// So that jQuery could be accessible from inline scripts
window.jQuery = $;
window.$ = $;

// Initialize the app
$(() => {
  ActiveStorage.start();

  tinymce.init({
    selector: '#editor',
    plugins: ['paste', 'link', 'code'],
  });

  $('.select2').select2();

  $('.use-select2.academics').each((index, element) => {
    const options = {};
    const $elem = $(element);
    const endpoint = $elem.attr('data-api-endpoint');
    const extraParams = $elem.data('extra-params');
    const select2Options = $elem.data('select2-options');

    if (endpoint !== undefined) {
      options.ajax = {
        url: endpoint,
        data: params => ({
          query: params.term,
          page: params.page,
          ...extraParams
        }),
        processResults: data => ({
          results: data.items.map(item => ({
            id: item.id,
            text: '[' + item.academic_number + '] ' + item.name_i18n
          })),
          pagination: {
            more: (data.page < data.num_pages)
          }
        })
      };
    }
    if (select2Options !== undefined) {
      Object.assign(options, select2Options);
    }

    $elem.select2(options);
  });

  $('.use-select2.students').each((index, element) => {
    const options = {};
    const $elem = $(element);
    const endpoint = $elem.attr('data-api-endpoint');
    const extraParams = $elem.data('extra-params');

    if (endpoint !== undefined) {
      options.ajax = {
        url: endpoint,
        data: params => ({
          query: params.term,
          page: params.page,
          ...extraParams
        }),
        processResults: data => ({
          results: data.items.map(item => ({
            id: item.id,
            text: '[' + item.student_number + '] ' + item.name_i18n
          })),
          pagination: {
            more: (data.page < data.num_pages)
          }
        })
      };
    }

    $(element).select2(options);
  });

  $('.use-select2.classrooms').each((index, element) => {
    const options = {};
    const endpoint = $(element).attr('data-api-endpoint');

    if (endpoint !== undefined) {
      options.ajax = {
        url: endpoint,
        data: params => {
          const ta_sa_request_term = $(element).attr('data-filter-ta-sa-request-term');
          const groups = $(element).attr('data-filter-groups');
          const year = $(element).attr('data-filter-year');
          return {
            ...(ta_sa_request_term === undefined ? {} : {ta_sa_request_term}),
            ...(groups === undefined ? {} : {group: groups.split(',')}),
            ...(year === undefined ? {} : {year}),
            query: params.term,
            page: params.page
          };
        },
        processResults: data => ({
          results: data.items.map(item => ({
            id: item.id,
            text: item.option_text
          })),
          pagination: {
            more: (data.page < data.num_pages)
          }
        })
      };
    }

    $(element).select2(options);
  });

  $('.use-select2.copyable-classrooms').each((index, element) => {
    const options = {};
    const endpoint = $(element).attr('data-api-endpoint');

    if (endpoint !== undefined) {
      options.ajax = {
        url: endpoint,
        data: params => {
          const syllabus_id = $(element).attr('data-filter-syllabus-id')
          const year = $(element).attr('data-filter-year');
          return {
            ...(year === undefined ? {} : {year}),
            ...(syllabus_id === undefined ? {} : {syllabus_id}),
            query: params.term,
            page: params.page
          };
        },
        processResults: data => ({
          results: data.items.map(item => ({
            id: item.id,
            text: item.option_text
          })),
          pagination: {
            more: (data.page < data.num_pages)
          }
        })
      };
    }

    $(element).select2(options);
  });

  $('.use-select2.ta-sa-request-terms').each((index, element) => {
    const options = {};
    const endpoint = $(element).attr('data-api-endpoint');

    if (endpoint !== undefined) {
      options.ajax = {
        url: endpoint,
        data: params => ({
          query: params.term,
          page: params.page
        }),
        processResults: data => ({
          results: data.items.map(item => ({
            id: item.id,
            text: item.option_text
          })),
          pagination: {
            more: (data.page < data.num_pages)
          }
        })
      };
    }

    $(element).select2(options);
  });

  $('.use-select2.graduate-school-seminar-schedules, .use-select2.graduate-school-committee-meeting-schedules, .use-select2.original-syllabus-proposal-application-periods').each((index, element) => {
    const options = {};
    const $elem = $(element);
    const endpoint = $elem.attr('data-api-endpoint');
    const extraParams = $elem.data('extra-params');
    const select2Options = $elem.data('select2-options');

    if (endpoint !== undefined) {
      options.ajax = {
        url: endpoint,
        data: params => ({
          query: params.term,
          page: params.page,
          ...extraParams
        }),
        processResults: data => ({
          results: data.items.map(item => ({
            id: item.id,
            text: item.option_text
          })),
          pagination: {
            more: (data.page < data.num_pages)
          }
        })
      };
    }
    if (select2Options !== undefined) {
      Object.assign(options, select2Options);
    }

    $elem.select2(options);
  });

  $('.select2-with-ajax').each((index, element) => {
    const options = {};
    const endpoint = $(element).attr('data-api-endpoint');
    const parentAttribute = $(element).attr('data-parent-attribute');

    if (endpoint !== undefined) {
      options.ajax = {
        url: endpoint,
        data: params => ({
          query: params.term,
          page: params.page,
          parent_id: $(parentAttribute).val()
        }),
        processResults: data => ({
          results: data.items.map(item => ({
            id: item.option_id,
            text: item.option_text
          })),
          pagination: {
            more: (data.page < data.num_pages)
          }
        })
      };
    }

    $(element).select2(options);
  });

  $('.pass-level-slider').ionRangeSlider({
    min: 1,
    max: 9,
    values: [...Array(9).keys()].map(val => val + 1),
    grid: true,
    skin: 'square'
  });

  const $taSaRequestTerms = $('.classroom-group-editor select.ta-sa-request-terms');
  const $classrooms = $('.classroom-group-editor select.classrooms');
  const enableClassrooms = () => {
    $classrooms.prop('disabled', ($taSaRequestTerms.val() === null));
  };
  enableClassrooms();
  $taSaRequestTerms.change(() => {
    if ($classrooms.attr('data-filter-ta-sa-request-term') !== $taSaRequestTerms.val()) {
      $classrooms.attr('data-filter-ta-sa-request-term', $taSaRequestTerms.val());
      $classrooms.val(null).trigger('change');
      enableClassrooms();
    }
  });

  const $bankNumber = $('.select2.bank-number');
  if ($bankNumber.length > 0) {
    const $bankOfficeNumber = $('.bank-office-number');
    $bankNumber.on('change', () => {
      $bankOfficeNumber.val(null).trigger('change');
      $bankOfficeNumber.empty();
    });
  }

  const $copySyllabusYear = $('#syllabus-copy select.year');
  const $copySyllabusId = $('#syllabus-copy select.id');
  const $copySyllabusButtons = $('#syllabus-copy button');
  const enableCopySyllabusButtons = () => {
    $copySyllabusButtons.prop('disabled', ($copySyllabusId.val() === null || $copySyllabusId.val() == ''));
  };
  enableCopySyllabusButtons();
  $copySyllabusYear.on('change', () => {
    if ($copySyllabusId.attr('data-filter-year') !== $copySyllabusYear.val()) {
      $copySyllabusId.attr('data-filter-year', $copySyllabusYear.val());
      $copySyllabusId.val(null).trigger('change');
    }
  });
  $copySyllabusId.on('change', () => {
    enableCopySyllabusButtons();
  });

  const initPictureCollection = ($container) => {
    const endpointUrl = $container.attr('data-api-endpoint');
    const needsReloadAfterExtraction = $container.data('needs-reload-after-extraction');
    const $state = $container.find('.state');
    const $progressBar = $container.find('.progress-bar');
    const $registerButton = $container.find('.register-button');
    const $abortButton = $container.find('.abort-button');
    const $deleteButton = $container.find('.delete-button');
    const $pictureTable = $container.find('.extracted-pictures');
    const $pictures = $pictureTable.find('tbody tr');

    const pictureIds = [];
    $pictures.each((index, element) => {
      const id = $(element).attr('data-picture-id');
      pictureIds.push(id);
    });
    const extra = pictureIds.join(',');

    const updateProcessingStatus = (json) => {
      const processingStatus = json.processing_status;

      $state.text(processingStatus.state);
      $progressBar.attr('aria-valuenow', json.percentage);
      $progressBar.css('width', json.percentage + '%');

      if (needsReloadAfterExtraction && !processingStatus.extracting) {
          window.location.reload();
      }

      if (processingStatus.registerable) {
        $registerButton.removeClass('disabled');
      } else {
        $registerButton.addClass('disabled');
      }

      if (processingStatus.abortable) {
        $abortButton.removeClass('disabled');
      } else {
        $abortButton.addClass('disabled');
      }

      if (processingStatus.destroyable) {
        $deleteButton.removeClass('disabled');
      } else {
        $deleteButton.addClass('disabled');
      }

      $pictures.each((index, element) => {
        const id = $(element).attr('data-picture-id');
        $(element).find('.picture-state').text(processingStatus.pictures[id]);
      });
    }

    const pollProcessingStatus = () => {
      $.ajax(endpointUrl, {
        data: { extra },
        success: (json) => {
          updateProcessingStatus(json);
          setTimeout(pollProcessingStatus, 2500);
        },
        error: (xhr, textStatus) => {
          if (textStatus !== 'abort') {
            $state.text('Communication Error');
            setTimeout(pollProcessingStatus, 2500);
          }
        },
        timeout: 10000
      });
    };

    pollProcessingStatus();
  };

  const $studentPictureCollection = $('.student-picture-collection');
  if ($studentPictureCollection.length > 0) {
    initPictureCollection($studentPictureCollection);
  }

  $('.sortable.lectures').sortable({
    items: '> div.lecture',
    handle: '.handle',
    cursor: 'grabbing',
    update: (event, ui) => {
      ui.item.parent().children('div.lecture').each((index, element) => {
        $(element).find('.position-display').text(index + 1);
        $(element).find('.position-input').val(index + 1);
      });
    }
  });

  $('th.sorting, th.sorting_asc, th.sorting_desc').on('click', (event) => {
    const $anchors = $(event.target).find('a');
    if ($anchors.length > 0) {
      window.location = $anchors[0].href;
    }
  });

  $('.co-research-advisors').on('change', (event) => {
    const $target = $(event.target);
    const $coResearchAdvisorSelect = $target.closest('.co-research-advisor-select');
    const $coResearchAdvisorInput = $coResearchAdvisorSelect.siblings('.co-research-advisor-input');
    $coResearchAdvisorInput.find('input').prop({disabled: $target.val() !== ''});
  }).trigger('change');

  $('.group-approval-notice').on('sola:launch', (event) => {
    const $target = $(event.target);
    const academicsPath = $target.data('api-academics-path');
    const researchAdvisors = $target.data('research-advisors');
    const email = [];
    for (const advisor of researchAdvisors) {
      if (advisor.email !== '' && advisor.email !== null) {
        email.push(advisor.email);
      }
    }
    if (!email.length) {
      $target.find('.continue').click();
      return;
    }

    const academicsByEmail = {};
    const onError = (xhr, textStatus) => {
      if (textStatus !== 'abort') {
        alert('Communication Error');
      }
    };
    const onSuccess = (json) => {
      for (const item of json.items) {
        academicsByEmail[item.email.toLowerCase()] = item;
      }
      if (json.current_page < json.num_pages) {
        $.ajax(academicsPath, {
          data: { email, all: true, page: json.current_page + 1 },
          success: onSuccess,
          error: onError,
          timeout: 10000
        });
      } else {
        const $registeredBlock = $target.find('.registered-advisors');
        const $registeredList = $registeredBlock.find('ul');
        const $registeredTemplate = $registeredBlock.find('template');
        const $unregisteredBlock = $target.find('.unregistered-advisors');
        const $unregisteredList = $unregisteredBlock.find('ul');
        const $unregisteredTemplate = $unregisteredBlock.find('template');
        $registeredList.empty();
        $unregisteredList.empty();
        for (const advisor of researchAdvisors) {
          if (advisor.email !== '' && advisor.email !== null) {
            const academic = academicsByEmail[advisor.email.toLowerCase()];
            if (academic === undefined) {
              const $newItem = $unregisteredTemplate.contents().clone();
              $newItem.find('.advisor-name-ja').text(advisor.name);
              $newItem.find('.advisor-name-en').text(advisor.name_en);
              $newItem.find('.advisor-email').text(advisor.email);
              $unregisteredList.append($newItem);
            } else {
              const $newItem = $registeredTemplate.contents().clone();
              $newItem.find('.academic-name-ja').text(academic.name);
              $newItem.find('.academic-name-en').text(academic.name_en);
              $newItem.find('.advisor-name-ja').text(advisor.name);
              $newItem.find('.advisor-name-en').text(advisor.name_en);
              $newItem.find('.advisor-email').text(advisor.email);
              $registeredList.append($newItem);
            }
          }
        }
        let shown = false;
        if ($registeredList.children().length > 0) {
          $registeredBlock.show();
          shown = true;
        } else {
          $registeredBlock.hide();
        }
        if ($unregisteredList.children().length > 0) {
          $unregisteredBlock.show();
          shown = true;
        } else {
          $unregisteredBlock.hide();
        }
        if (shown) {
          $target.modal();
        } else {
          $target.find('.continue').click();
        }
      }
    };
    $.ajax(academicsPath, {
      data: { email, all: true },
      success: onSuccess,
      error: onError,
      timeout: 10000
    });
  });
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
